module.exports = __webpack_public_path__ + "static/media/13_avatar.b35beb09.png";